import {ConnectedDevice} from "../../device/adapter";

export class Lifecycle {

  constructor(
    /**
     * Connected device
     */
    public connectedDevice: ConnectedDevice,
  ) {
  }


}
